import { Container } from 'inversify';
import { ICurrentUserStore } from '../infrastructure/auth/current-user-store';
import { IAdminService, ICategoryService, INewsContentService, IUserFsrsCardService, IQuizzService, ISyncApiService, IUserPreferencesService } from '@lingvo-news/contracts';
import { CurrentUserStore } from '../infrastructure/auth/current-user-store-impl';
import { bindHttpServiceClients } from '../infrastructure/services/http-service-client-registrar';
import { createClient } from '../infrastructure/services/runtime-service-client';

export const SERVICE_TYPES = {
	ApiBaseUrl: Symbol.for('ApiBaseUrl'),
	CurrentUserStore: Symbol.for('CurrentUserStore'),
} as const;

function getViteEnv(): Record<string, string | undefined> | undefined {
	const meta = import.meta as unknown as { env?: Record<string, string | undefined> };
	return meta.env;
}

const apiBaseUrl = getViteEnv()?.VITE_API_BASE_URL ?? '';

export const serviceContainer = new Container({ defaultScope: 'Singleton' });

serviceContainer.bind<string>(SERVICE_TYPES.ApiBaseUrl).toConstantValue(apiBaseUrl);
serviceContainer.bind(ICurrentUserStore).to(CurrentUserStore);

bindHttpServiceClients(serviceContainer, apiBaseUrl);

export function resolveContentService(): INewsContentService {
	return serviceContainer.get(INewsContentService);
}


export function resolveUserWordsService(): IUserFsrsCardService {
	return serviceContainer.get(IUserFsrsCardService);
}

export function resolveQuizzService(): IQuizzService {
	return serviceContainer.get(IQuizzService);
}

export function resolveCurrentUserStore(): ICurrentUserStore {
	return serviceContainer.get<ICurrentUserStore>(ICurrentUserStore);
}

